var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loading-spinner"}):_c('SearchReport',{attrs:{"project":_vm.project,"report":_vm.report}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }